import _async_to_generator from "@swc/helpers/src/_async_to_generator.mjs";
import _ts_generator from "@swc/helpers/src/_ts_generator.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { checkoutTimes, returnToCheckoutStage, personalDetailsPagePath, findVehiclePath } from "@cinch-labs/shared-util";
import { Text } from "@cinch-labs/design-system";
import { useState, useEffect, useCallback, useMemo } from "react";
import styles from "../return-to-checkout-modal.module.css";
import { TimeIcon } from "../image-components/time";
import { i18n } from "../return-to-checkout-modal.component";
import { ModalState } from "../return-to-checkout-modal.types";
import { TrackingEventTypes } from "../types/analytics";
import { useReturnToCheckoutModalTracking } from "../return-to-checkout-modal.tracking";
var hasExpired = function(expiresAt) {
    return expiresAt === undefined ? false : Date.now() > expiresAt;
};
export var useReturnToCheckoutModal = function(param) {
    var activeOrder = param.activeOrder, timeRemainingInSeconds = param.timeRemainingInSeconds, withinExpiryTimeWindow = param.withinExpiryTimeWindow, checkIfVehicleIsReserved = param.checkIfVehicleIsReserved, accessToken = param.accessToken, extendOrderExpiryDate = param.extendOrderExpiryDate, refreshActiveOrder = param.refreshActiveOrder, cancelOrder = param.cancelOrder, onClose = param.onClose, isLoggedIn = param.isLoggedIn, handleShouldShowBasketIcon = param.handleShouldShowBasketIcon, lastVisitedCheckoutStage = param.lastVisitedCheckoutStage, trackEvent = param.trackEvent;
    var ref = useReturnToCheckoutModalTracking(trackEvent !== null && trackEvent !== void 0 ? trackEvent : noOpTracking), resumeCheckoutClosedModal = ref.resumeCheckoutClosedModal, resumeCheckoutReturnedToCheckout = ref.resumeCheckoutReturnedToCheckout, iDoNotWantThisCarEvent = ref.iDoNotWantThisCarEvent, returnToCheckoutModalEvent = ref.returnToCheckoutModalEvent, resumeCheckoutOpenedModal = ref.resumeCheckoutOpenedModal;
    var vehicle = useMemo(function() {
        return activeOrder === null || activeOrder === void 0 ? void 0 : activeOrder.vehicle;
    }, [
        activeOrder === null || activeOrder === void 0 ? void 0 : activeOrder.vehicle
    ]);
    var orderId = useMemo(function() {
        return activeOrder === null || activeOrder === void 0 ? void 0 : activeOrder.id;
    }, [
        activeOrder === null || activeOrder === void 0 ? void 0 : activeOrder.id
    ]);
    var ref1 = useState(activeOrder), currentOrder = ref1[0], setCurrentOrder = ref1[1];
    var ref2 = useState(false), buttonLoading = ref2[0], setButtonLoading = ref2[1];
    var ref3 = useState(false), secondaryButtonLoading = ref3[0], setSecondaryButtonLoading = ref3[1];
    var ref4 = useState(false), vehicleIsReserved = ref4[0], setVehicleIsReserved = ref4[1];
    var ref5 = useState(false), modalLoading = ref5[0], setModalLoading = ref5[1];
    var ref6 = useState(timeRemainingInSeconds), timeLeft = ref6[0], setTimeLeft = ref6[1];
    var ref7 = useState(withinExpiryTimeWindow), expiringSoon = ref7[0], setExpiringSoon = ref7[1];
    var ref8;
    var ref9 = useState(hasExpired((ref8 = activeOrder === null || activeOrder === void 0 ? void 0 : activeOrder.expiresAt) !== null && ref8 !== void 0 ? ref8 : activeOrder === null || activeOrder === void 0 ? void 0 : activeOrder.cancelledAt)), orderHasExpired = ref9[0], setOrderHasExpired = ref9[1];
    useEffect(function() {
        var ref;
        setOrderHasExpired(hasExpired((ref = currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.expiresAt) !== null && ref !== void 0 ? ref : currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.cancelledAt));
        if (orderHasExpired) {
            return;
        }
        var id = setTimeout(function() {
            var times = checkoutTimes(activeOrder);
            setTimeLeft(times.timeRemainingInSeconds);
            setExpiringSoon(!!times.isExpiringSoon);
        }, 1000);
        return function() {
            return clearTimeout(id);
        };
    }, [
        timeLeft
    ]);
    useEffect(function() {
        if (activeOrder && orderHasExpired && checkIfVehicleIsReserved) {
            setModalLoading(true);
            var getReservationStatus = function() {
                var _ref = _async_to_generator(function() {
                    var reservationStatus;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    checkIfVehicleIsReserved(activeOrder.vehicle.id)
                                ];
                            case 1:
                                reservationStatus = _state.sent();
                                setVehicleIsReserved(reservationStatus === null || reservationStatus === void 0 ? void 0 : reservationStatus.reserved);
                                setModalLoading(false);
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function getReservationStatus() {
                    return _ref.apply(this, arguments);
                };
            }();
            getReservationStatus();
        }
    }, [
        activeOrder,
        orderHasExpired,
        vehicle,
        checkIfVehicleIsReserved
    ]);
    var extendExpiry = useCallback(/*#__PURE__*/ _async_to_generator(function() {
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!accessToken) {
                        return [
                            2
                        ];
                    }
                    if (!orderId) return [
                        3,
                        2
                    ];
                    setButtonLoading(true);
                    return [
                        4,
                        extendOrderExpiryDate === null || extendOrderExpiryDate === void 0 ? void 0 : extendOrderExpiryDate(orderId, accessToken)
                    ];
                case 1:
                    _state.sent();
                    setButtonLoading(false);
                    _state.label = 2;
                case 2:
                    return [
                        2
                    ];
            }
        });
    }), [
        orderId,
        extendOrderExpiryDate,
        accessToken
    ]);
    var removeOrderForUser = function() {
        var _ref = _async_to_generator(function(token) {
            var cancelOrderReason, ref, orderDetails, _tmp, e;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        cancelOrderReason = "Return to Checkout - I don't want this car";
                        if (!refreshActiveOrder) {
                            return [
                                2
                            ];
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        _tmp = activeOrder;
                        if (!_tmp) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            cancelOrder === null || cancelOrder === void 0 ? void 0 : cancelOrder(activeOrder.id, cancelOrderReason, token)
                        ];
                    case 2:
                        _tmp = _state.sent();
                        _state.label = 3;
                    case 3:
                        orderDetails = _tmp;
                        switch((orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.status) || ((ref = // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.data) === null || ref === void 0 ? void 0 : ref.orderStatus) === "Cancelled"){
                            case 200:
                                setCurrentOrder(orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.data);
                                refreshActiveOrder();
                                onClose();
                                handleShouldShowBasketIcon();
                                break;
                            case 403:
                                handleShouldShowBasketIcon();
                                window.location.assign("/login");
                                break;
                            default:
                                refreshActiveOrder();
                                break;
                        }
                        return [
                            2,
                            setSecondaryButtonLoading(false)
                        ];
                    case 4:
                        e = _state.sent();
                        // eslint-disable-next-line unicorn/no-useless-undefined
                        setCurrentOrder(undefined);
                        refreshActiveOrder();
                        return [
                            2,
                            setSecondaryButtonLoading(false)
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function removeOrderForUser(token) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleRemoveOrder = function() {
        var _ref = _async_to_generator(function() {
            var isUserValid;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        iDoNotWantThisCarEvent();
                        setSecondaryButtonLoading(true);
                        isUserValid = accessToken && isLoggedIn;
                        if (!!isUserValid) return [
                            3,
                            1
                        ];
                        window.location.assign("/login");
                        return [
                            3,
                            3
                        ];
                    case 1:
                        return [
                            4,
                            removeOrderForUser(accessToken)
                        ];
                    case 2:
                        _state.sent();
                        _state.label = 3;
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleRemoveOrder() {
            return _ref.apply(this, arguments);
        };
    }();
    var onModalOpen = function(modalState) {
        resumeCheckoutOpenedModal(modalState);
    };
    var onModalClose = function(modalState) {
        resumeCheckoutClosedModal(modalState);
        onClose();
    };
    var onButtonClick = function() {
        var _ref = _async_to_generator(function() {
            var ref;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        returnToCheckoutModalEvent();
                        return [
                            4,
                            extendExpiry()
                        ];
                    case 1:
                        _state.sent();
                        returnToCheckoutStage((ref = lastVisitedCheckoutStage === null || lastVisitedCheckoutStage === void 0 ? void 0 : lastVisitedCheckoutStage.stage) !== null && ref !== void 0 ? ref : "PersonalDetails", activeOrder);
                        return [
                            2
                        ];
                }
            });
        });
        return function onButtonClick() {
            return _ref.apply(this, arguments);
        };
    }();
    var onButtonClickExpiredOrderVehicleStillAvailable = function() {
        resumeCheckoutReturnedToCheckout(ModalState.expiredStillAvailable);
        vehicle && window.location.assign("".concat(personalDetailsPagePath).concat(vehicle.id));
    };
    var onButtonClickExpiredOrderVehicleUnavailable = function() {
        refreshActiveOrder && refreshActiveOrder();
        resumeCheckoutReturnedToCheckout(ModalState.expiredUnavailable);
        window.location.assign(findVehiclePath);
    };
    var onModalCloseExpiredOrderVehicleUnavailable = function() {
        refreshActiveOrder && refreshActiveOrder();
        resumeCheckoutClosedModal(ModalState.expiredStillAvailable);
        onClose();
    };
    return {
        vehicle: vehicle,
        orderHasExpired: orderHasExpired,
        timeLeft: timeLeft,
        buttonLoading: buttonLoading,
        secondaryButtonLoading: secondaryButtonLoading,
        vehicleIsReserved: vehicleIsReserved,
        modalLoading: modalLoading,
        expiringSoon: expiringSoon,
        handleRemoveOrder: handleRemoveOrder,
        onModalOpen: onModalOpen,
        onModalClose: onModalClose,
        onButtonClick: onButtonClick,
        onButtonClickExpiredOrderVehicleStillAvailable: onButtonClickExpiredOrderVehicleStillAvailable,
        onButtonClickExpiredOrderVehicleUnavailable: onButtonClickExpiredOrderVehicleUnavailable,
        onModalCloseExpiredOrderVehicleUnavailable: onModalCloseExpiredOrderVehicleUnavailable
    };
};
export var noOpTracking = function(event) {
    console.log("noop::trackEvent::".concat(event.type !== TrackingEventTypes.IDENTIFY && event.eventName), event);
};
export var styleCardTitle = function(title, icon) {
    if (icon) {
        return /*#__PURE__*/ _jsx(Text, {
            element: "h5",
            className: styles.cardTitle,
            children: /*#__PURE__*/ _jsxs("div", {
                className: styles.titleWithIconContainer,
                "data-testid": "time-icon-modal-title",
                children: [
                    /*#__PURE__*/ _jsx(TimeIcon, {
                        className: styles.timeIcon
                    }),
                    title
                ]
            })
        });
    }
    return /*#__PURE__*/ _jsx(Text, {
        element: "h5",
        className: styles.cardTitle,
        children: title
    });
};
export var getTitle = function(modalState) {
    switch(modalState){
        case ModalState.active:
            return styleCardTitle(i18n.orderActive.title);
        case ModalState.expiringSoon:
            return styleCardTitle(i18n.expiringSoon.title, true);
        case ModalState.expiredStillAvailable:
            return styleCardTitle(i18n.expiredStillAvailable.title, true);
        case ModalState.expiredUnavailable:
            return styleCardTitle(i18n.expiredUnavailable.title);
    }
};
